import * as React from 'react';
/**
 *
 * Original name: shield
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1098
 *
 */
export const ShieldLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m9.78 10.72-1.06 1.06 2.78 2.78 4.28-4.28-1.06-1.06-3.22 3.22-1.72-1.72Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "m12 3.918-7 3.36V11c0 6.186 6.447 8.837 6.722 8.947l.278.111.278-.111C12.553 19.837 19 17.187 19 11V7.278l-7-3.36ZM17.5 11c0 4.5-4.345 6.875-5.5 7.427C10.844 17.875 6.5 15.5 6.5 11V8.222l5.5-2.64 5.5 2.64V11Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
